import Box from '@/components/UI/box/Box';
import MapLoading from '../reusable/mapLoading/MapLoading';
import dynamic from 'next/dynamic';
import { ProductListRecord } from '@/components/reusable/productCard/types';
interface MobileMapProps {
  data: ProductListRecord[];
  loading: boolean;
  isTehran: boolean;
}
const Map = dynamic(() => import('@/components/reusable/map/Map'), {
  ssr: false,
  loading: () => <Box style={{
    height: '90vh'
  }}>
      <MapLoading />
    </Box>
});
const MobileMap = ({
  data,
  loading,
  isTehran
}: MobileMapProps) => {
  return <Map houses={data} loading={loading} isTehran={isTehran} isMobile data-sentry-element="Map" data-sentry-component="MobileMap" data-sentry-source-file="MobileMap.tsx" />;
};
export default MobileMap;